import React from 'react';
import { useNotifications } from '../context/NotificationContext';

const ToastItem = ({ n, onClose }) => (
  <div className="mb-2 p-3 rounded-2xl shadow-xl bg-blue-900 border border-blue-950/40 w-full sm:w-80 text-white overflow-hidden">
    <div className="flex items-start justify-between">
      <div className="min-w-0">
        <div className="font-semibold text-sm text-white break-words break-all whitespace-normal">{n.title}</div>
        {n.description && (
          <div className="text-xs text-white/80 mt-1 break-words break-all whitespace-pre-wrap line-clamp-3">{n.description}</div>
        )}
      </div>
      <button
        type="button"
        className="text-white/70 hover:text-white"
        onClick={() => onClose(n.id)}
        aria-label="بستن"
      >×</button>
    </div>
    {n.count ? (
      <div className="text-[11px] text-white/70 mt-1 break-words break-all">تجمیع: {n.count} رویداد</div>
    ) : null}
  </div>
);

const Banner = ({ b, onClose, onMute }) => (
  <div className={`p-3 ${b.type === 'sla' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'} border-b`}> 
    <div className="container mx-auto px-4 flex items-center justify-between">
      <div>
        <div className="font-semibold">{b.title}</div>
        {b.description && <div className="text-sm">{b.description}</div>}
      </div>
      <div className="flex items-center gap-2">
        <button className="text-xs px-2 py-1 rounded border" onClick={onClose}>رد کردن</button>
        <button className="text-xs px-2 py-1 rounded border" onClick={() => onMute(15)}>سکوت ۱۵ دقیقه</button>
      </div>
    </div>
  </div>
);

export default function NotificationsUI() {
  const { notifications, removeNotification, banner, hideBanner, muteForMinutes } = useNotifications();
  return (
    <>
      {banner && (
        <Banner b={banner} onClose={hideBanner} onMute={muteForMinutes} />
      )}
      <div className={`fixed right-0 left-0 sm:left-auto sm:right-4 z-[1150] ${banner ? 'top-[140px] sm:top-20' : 'top-[140px] sm:top-4'}`}>
        {notifications.map(n => (
          <ToastItem key={n.id} n={n} onClose={removeNotification} />
        ))}
      </div>
    </>
  );
}
